import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SocialLink } from '@/models'
import { resetQueries } from '@/utils'

interface GetSocialLinksRequest {
  buildingId: number
}

export const USE_GET_SOCIAL_LINKS_QUERY_KEY = 'useGetSocialLinks'

export const getSocialLinksQueryKey = (data: GetSocialLinksRequest) => [
  USE_GET_SOCIAL_LINKS_QUERY_KEY,
  data,
]

export const getSocialLinks = async (data: GetSocialLinksRequest): Promise<SocialLink[]> => {
  const response = await authAPI.get<SocialLink[]>('/sociallink', {
    params: { buildingId: data.buildingId },
  })
  return response.data
}

export const useGetSocialLinks = (data: GetSocialLinksRequest) => {
  return useQuery({
    queryFn: () => getSocialLinks(data),
    queryKey: getSocialLinksQueryKey(data),
  })
}

export const useInvalidateSocialLinks = () => {
  return () => resetQueries([USE_GET_SOCIAL_LINKS_QUERY_KEY])
}
